import { messages } from './messages';

export type FormName = keyof typeof messages.forms;
export type FormioName = keyof typeof messages.pgbaForms;

/**
 * Add to these list to dynamically display forms.
 * Use form id from apps/forms/src/containers/Forms/messages.ts
 * */
export const activeFormsList: Array<FormName> = [];
export const readOnlyFormioList = [
  'electionaddendum',
  'covid19',
  'idg-pgba',
  'idg-lcd',
];
export const comingSoonFormsList: Array<FormName> = [
  'nursing',
  'socialServices',
  'spiritual',
  'physician',
  'volunteer',
  'fallRisk',
];
